// 注意：此文件已不再使用，API 地址现在通过环境变量配置
// 开发/测试环境: 'http://8.130.210.205'
// 正式环境: https://test.erp.duobaby.net/api
// 如需修改 API 地址，请修改 config/dev.env.js 或 config/prod.env.js
window.g={
  baseUrl:""
}




//////////////////
// WEBPACK FOOTER
// ./static/js/config.js
// module id = wAX/
// module chunks = 1